module.exports = __webpack_public_path__ + "img/07-42.8cb08dd3.png";